import { useTranslation } from 'next-i18next';
import type { FC } from 'react';

import StatusMessageBox from 'components/StatusMessageBox';

const AddRfidSuccess: FC = () => {
  const { t } = useTranslation();

  return (
    <StatusMessageBox
      type="success"
      message={t('common:pages.rfids.rfid_added')}
    />
  );
};

export default AddRfidSuccess;
